export default __webpack_public_path__ + "3c77f9a86d51b1ab4368d3634885847b.png";